<template>
  <div>
    <base-subheader>
      <div v-html="item.title"></div>
    </base-subheader>

    <v-img
      class="mt-5"
      max-height="300px"
      max-width="500px"
      aspect-ratio="1"
      contain
      v-if="item.image"
      :src="item.image"
      :alt="item.title"
    ></v-img>

    <div class="ml-3 mt-5">
      <div class="d-md-flex justify-space-between">
        <div class="text-h5">
          <div v-html="item.subtitle"></div>
        </div>
        <v-chip v-bind="{ color: 'blue-grey darken-2' }" dark>
          {{ item.append_price ? item.append_price : "" }} {{ item.price }}
          {{ item.price_unit ? item.price_unit : "€" }}
        </v-chip>
      </div>
      <div class="mt-2" v-html="item.description"></div>
    </div>
    <v-checkbox
      :disabled="$store.getters.isDisabled"
      :label="item.button"
      :input-value="value"
      @change="$emit('input', $event)"
    ></v-checkbox>

    <!-- <pre>item: {{ item }}</pre> -->
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
      /*
       demo: {
           title: String,
           subtitle: String,
           description: String,
           button: String,
           price: Number
           image: String,
           images: Array
       }
       */
    },
    value: {
      type: Boolean,
      default: null,
    },
  },
};
</script>

<style>
</style>
